import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import 'CssFolder/chart.scss';

export default function AttendanceWorkTypePieChartComponent() {

    let chart;
    let chartId = 'piechart_attendance_work_type';
    let root;
    let series;
    let legend;

    let onWorkTypeChartDataChanged = (_data) => {
        if (_data) {
            am5.array.each(am5.registry.rootElements, function (root) {
                if (root && root.dom.id == chartId) {
                    root.dispose();
                }
            });
            initChart(_data);
        }
    }

    function initChart(_data) {
        createChart();
        createSeries();
        loadData(_data);
        createLegend();
        // Animate on when appear
        series.appear(1000, 100);
    }

    function createChart() {
        root?.dispose(); // dispose any pre-existing roots
        root = am5.Root.new(chartId);

        root.setThemes([
            am5themes_Responsive.new(root),
            am5themes_Animated.new(root)
        ]);

        chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                radius: am5.percent(80),
                layout: root.horizontalLayout,
            })
        );

    }

    function createSeries() {
        series = chart.series.push(am5percent.PieSeries.new(root, {
            alignLabels: true,
            calculateAggregates: true,
            valueField: "count",
            categoryField: "workTypeName",
            legendLabelText: "{workTypeName}:",
            legendValueText: "[fontSize: 12px;bold]{count}[/]",
            tooltip: am5.Tooltip.new(root, {
                labelText: "{workTypeName}: {count}"
            })
        }));

        series.get("colors").set("colors", [
            am5.color(0x1428A0), // Blue
            am5.color(0xFE4335), // Orange
            am5.color(0xFEB545), // Yellow mustard
            am5.color(0x01B3E3), // Light blue
            am5.color(0x97D654), // Green
            am5.color(0x001737), // Black
            am5.color(0xB5B5B5), // Grey
        ]);

        series.slices.template.setAll({
            strokeWidth: 3,
            stroke: am5.color(0xFFFFFF)
        });

        series.labels.template.setAll({
            radius: 0,
            fontSize: 10,
            textAlign: "right",
            text: "{workTypeName}:\n[bold]{valuePercentTotal.formatNumber('0.0')}%[/] ({count})",
        });

        // series.slices.template.adapters.add("radius", function (radius, target) {
        //     var dataItem = target.dataItem;
        //     var high = series.getPrivate("valueHigh");

        //     if (dataItem) {
        //         var value = target.dataItem.get("valueWorking", 0);
        //         return radius * value / high
        //     }
        //     return radius;
        // });

        series.slices.template.adapters.add("fill", function (fill, target) {
            return series.get("colors").getIndex(series.dataItems.indexOf(target.dataItem));
        });
    }

    function loadData(_data) {
        series.data.setAll(_data);
    }

    function createLegend() {
        legend = chart.children.push(am5.Legend.new(root, {
            centerY: am5.p50,
            y: am5.p50,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            layout: root.verticalLayout,
        }));

        legend.labels.template.setAll({
            fontSize: 12,
            fontWeight: "300"
        });

        legend.data.setAll(series.dataItems);
    }

    return {
        oninit: function (vnode) {
            //chartId += chartModel.generateID();
        },
        oncreate: function (vnode) {
            if (vnode.attrs.events) {
                vnode.attrs.events.onWorkTypeChartDataChanged = onWorkTypeChartDataChanged;
            }
            if (vnode.attrs.data) {
                initChart(vnode.attrs.data);
            }
        },
        view: function (vnode) {
            return m('.chart', {
                id: chartId,
                style: 'min-width: 320px',
            });
        }
    }
}
